<template>
  <v-app>
    <AppBar></AppBar>
    <Content></Content>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Footer from "./components/Footer";
import AppBar from "./components/AppBar";
import Content from "./components/Content";
export default {
  name: "Index",
  components: { Content, AppBar, Footer }
};
</script>

<style scoped></style>
